import React, { useEffect, useState } from "react";
import "../../../../style.css";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  displayCommaFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useDispatch, useSelector } from "react-redux";
import {
  setDocViewTableData,
  setSelectedProbable,
  setSelectedRowProbable,
} from "containers/gstr2a2bNewEnhancement/Reconciliation/action";
import ReactPaginate from "react-paginate";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import UserComment from "../UserComment";
// let tableData = [
//   { id: "1", gstin: "1234567" },
//   { id: "2", gstin: "ABCD" },
// ];

const Table = (props) => {
  const dispatch = useDispatch();
  const {
    selectedProbable,
    docViewTableData,
    totalPageProbable,
    selectedRowProbable,
    pageNoProbable
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
  const [open, setOpen] = useState(false);
  const [commentRow, setCommentRow] = useState([]);

   const userCommentsFormatter = (cell, row) => {
    return (
      <div
        style={{
          width: "100%",
          cursor: "pointer",
          textDecoration: "underline",
          color: "#4f2d7f",
        }}
        onClick={() => {
          console.log("row::", row.TXN_ID);
          setCommentRow(row);
          setOpen(true);
        }}
      >
        {"Link"}
      </div>
    );
  };
  
  const handleCloseComment = () => {
    setOpen(false);
    setCommentRow([]);
  };

  const getHeaderStyle = (width) => ({
    ...commonHeaderStyle,
    width,
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    textWrap: "nowrap",
    wordBreak: "normal",
    lineHeight: 1,
  });

  const columns = [
    {
      dataField: "ORIGINAL_MATCH_TYPE",
      text: "Original Match Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) =>
        displayNullFormatter(row, "ORIGINAL_MATCH_TYPE"),
    },
     {
          dataField: "SUBCATEGORY",
          text: "Sub Category",
          style: (cell, row, rowIndex, colIndex) => ({
            ...commonStyle,
          }),
          headerStyle: getHeaderStyle("3.6%"),
          formatter: (cell, row) => displayNullFormatter(row, "SUBCATEGORY"),
        },
    {
      dataField: "GSTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN_PURCHASE"),
    },
    {
      dataField: "GSTIN",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "CTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_PURCHASE"),
    },
    {
      dataField: "CTIN_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_SALE"),
    },
    {
      dataField: "INUM_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "INUM_PURCHASE"),
    },
    {
      dataField: "INUM_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "INUM_SALE"),
    },
    {
      dataField: "IDT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "IDT_PURCHASE"),
    },
    {
      dataField: "IDT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "IDT_SALE"),
    },
    {
      dataField: "POS_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "POS_PURCHASE"),
    },
    {
      dataField: "POS_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "POS_SALE"),
    },
    {
      dataField: "TXVAL_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_PURCHASE"),
    },
    {
      dataField: "TXVAL_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_SALE"),
    },
    {
      dataField: "IAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_PURCHASE"),
    },
    {
      dataField: "IAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_SALE"),
    },
    {
      dataField: "CAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_PURCHASE"),
    },
    {
      dataField: "CAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_SALE"),
    },
    {
      dataField: "SAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_PURCHASE"),
    },
    {
      dataField: "SAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_SALE"),
    },
    {
      dataField: "CSAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_PURCHASE"),
    },
    {
      dataField: "CSAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_SALE"),
    },
    {
      dataField: "RETURN_PERIOD",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "RETURN_PERIOD"),
    },
    {
      dataField: "RET_PERIOD",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "GSTR2B_PERIOD",
      text: "GSTR-2B Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "GSTR2B_PERIOD"),
    },
    {
      dataField: "Report24",
      text: "Matched Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "Report24"),
    },
    {
      dataField: "ITC_AVAILABILITY",
      text: "ITC Availability as per 2B",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "ITC_AVAILABILITY"),
    },
    {
      dataField: "ITC_UNAVAILABILITY_REASON",
      text: "ITC Un-availability as per 2B reason",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("3.6%"),
      formatter: (cell, row) => displayNullFormatter(row, "ITC_UNAVAILABILITY_REASON"),
    },
    {
      dataField: "Report30",
      text: "User Comments",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: getHeaderStyle("2.8%"),
      // formatter: (cell, row) => displayNullFormatter(row, "Report30"),
      formatter: userCommentsFormatter,
    },
  ];

  const groupedHeaderConfig = [
    {
      title: "Recipient GSTIN",
      fields: ["GSTIN_PURCHASE", "GSTIN"],
    },
    {
      title: "Supplier GSTIN",
      fields: ["CTIN_PURCHASE", "CTIN_SALE"],
    },
    {
      title: "Document Number",
      fields: ["INUM_PURCHASE", "INUM_SALE"],
    },
    {
      title: "Document Date",
      fields: ["IDT_PURCHASE", "IDT_SALE"],
    },
    {
      title: "POS",
      fields: ["POS_PURCHASE", "POS_SALE"],
    },
    {
      title: "Taxable Value",
      fields: ["TXVAL_PURCHASE", "TXVAL_SALE"],
    },
    {
      title: "IGST",
      fields: ["IAMT_PURCHASE", "IAMT_SALE"],
    },
    {
      title: "CGST",
      fields: ["CAMT_PURCHASE", "CAMT_SALE"],
    },
    {
      title: "SGST",
      fields: ["SAMT_PURCHASE", "SAMT_SALE"],
    },
    {
      title: "CESS",
      fields: ["CSAMT_PURCHASE", "CSAMT_SALE"],
    },
    {
      title: "Tax Period",
      fields: ["RETURN_PERIOD", "RET_PERIOD"],
    },
  ];

  const standaloneHeaderFields = [
    { field: "ORIGINAL_MATCH_TYPE", title: "Original Match Type" },
    { field: "SUBCATEGORY", title: "Sub Category" },
    { field: "GSTR2B_PERIOD", title: "GSTR-2B Period" },
    { field: "Report24", title: "Matched Month" },
    { field: "ITC_AVAILABILITY", title: "ITC Availability as per 2B" },
    {
      field: "ITC_UNAVAILABILITY_REASON",
      title: "ITC Un-availability as per 2B reason",
    },
    { field: "Report30", title: "User Comments" },
  ];

  const allFieldOrder = [
    "ORIGINAL_MATCH_TYPE",
    "SUBCATEGORY",
    ...groupedHeaderConfig.flatMap((item) => item.fields),
    "GSTR2B_PERIOD",
    "Report24",
    "ITC_AVAILABILITY",
    "ITC_UNAVAILABILITY_REASON",
    "Report30",
  ];

  const columnsByField = columns.reduce((acc, column) => {
    acc[column.dataField] = column;
    return acc;
  }, {});

  const getColumnWidth = (field) => {
    if (field === "Report30") {
      return "2.8%";
    }
    return "3.6%";
  };

  const mergedHeaderStyle = {
    ...commonHeaderStyle,
    textAlign: "center",
    verticalAlign: "middle",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.2,
    paddingTop: "6px",
    paddingBottom: "6px",
    borderTop: "1px solid #4f2d7f",
    borderBottom: "1px solid #4f2d7f",
    borderLeft: "none",
    borderRight: "none",
  };

  const isAllSelected =
    docViewTableData?.length > 0 &&
    docViewTableData.every((row) => selectedProbable.includes(row.TXN_ID));
  // const columns = [
  //   {
  //     dataField: "Original Match Type",
  //     text: "Original Match Type",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },

  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTR-2B Period",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "Matched Month",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "ITC Availability as per 2B",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "ITC Un-availability as per 2B reason",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.125%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },

  //   {
  //     dataField: "Report",
  //     text: "User Comments",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "2.8%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  // ];
  function handleOnSelect(row, isSelect) {
    console.log("handleOnSelect called");
    if (isSelect) {
      dispatch(setSelectedProbable([...selectedProbable, row.TXN_ID]));
      dispatch(setSelectedRowProbable([...selectedRowProbable, row]));
    } else {
     
           const updatedNotInPr = selectedProbable.filter(id => id !== row.TXN_ID);
           dispatch(setSelectedProbable(updatedNotInPr));
     
           const updatedRows = selectedRowProbable.filter(r => r.TXN_ID !== row.TXN_ID);
           dispatch(setSelectedRowProbable(updatedRows));
    }
  }

  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.TXN_ID);
    if (isSelect) {
      dispatch(setSelectedProbable(ids));
      dispatch(setSelectedRowProbable(rows));
    } else {
      dispatch(setSelectedProbable([]));
      dispatch(setSelectedRowProbable([]));
    }
  }
  const selectRow = {
    mode: "checkbox",
    selected: selectedProbable,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
    },
  };
  useEffect(() => {
    return () => {
      dispatch(setSelectedProbable([]));
      dispatch(setDocViewTableData([]));
      dispatch(setSelectedRowProbable([]));
    };
  }, []);

  useEffect(() => {
    console.log("selectedProbable:", selectedProbable);
    console.log("selectedRowProbable:", selectedRowProbable);
  }, [selectedProbable, selectedRowProbable]);

  return (
    <>
      {docViewTableData?.length > 0 ? (
        <>
          {" "}
          <div
            id="tableDiv-scroll"
            className="light-border-gstr2a2bnew-table probable-docview-scroll docview-table-shell"
            style={{
              maxHeight: "500px",
              overflow: "hidden",
            }}
          >
            <div
              className="docview-scroll-inner docview-scrollbar"
              style={{
                overflowY: "hidden",
                maxHeight: "500px",
              }}
            >
              <table
                className="table table-bordered mb-0"
                style={{
                  width: "450%",
                  tableLayout: "fixed",
                  borderCollapse: "collapse",
                  backgroundColor: "#d9dbdf",
                  border: "none",
                }}
              >
              <thead>
                <tr>
                  <th
                    rowSpan={2}
                    style={{
                      ...mergedHeaderStyle,
                      width: "37px",
                      minWidth: "37px",
                      maxWidth: "37px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={(event) =>
                        handleOnSelectAll(event.target.checked, docViewTableData)
                      }
                    />
                  </th>

                  {standaloneHeaderFields.slice(0, 2).map((item) => (
                    <th
                      key={`top-standalone-${item.field}`}
                      rowSpan={2}
                      style={{ ...mergedHeaderStyle, width: getColumnWidth(item.field) }}
                    >
                      {item.title}
                    </th>
                  ))}

                  {groupedHeaderConfig.map((group) => (
                    <th
                      key={`group-${group.title}`}
                      colSpan={2}
                      style={{ ...mergedHeaderStyle, width: "7.2%" }}
                    >
                      {group.title}
                    </th>
                  ))}

                  {standaloneHeaderFields.slice(2).map((item) => (
                    <th
                      key={`top-standalone-tail-${item.field}`}
                      rowSpan={2}
                      style={{ ...mergedHeaderStyle, width: getColumnWidth(item.field) }}
                    >
                      {item.title}
                    </th>
                  ))}
                </tr>

                <tr>
                  {groupedHeaderConfig.map((group) =>
                    group.fields.map((field, index) => (
                      <th
                        key={`child-${group.title}-${field}`}
                        style={{ ...mergedHeaderStyle, width: getColumnWidth(field) }}
                      >
                        {index === 0 ? "PR" : "GSTN"}
                      </th>
                    ))
                  )}
                </tr>
              </thead>

              <tbody>
                {docViewTableData.map((row, rowIndex) => (
                  <tr key={row.TXN_ID || rowIndex} style={rowStyle2(row, rowIndex)}>
                    <td
                      style={{
                        ...commonStyle,
                        width: "37px",
                        minWidth: "37px",
                        maxWidth: "37px",
                        textAlign: "center",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid #4f2d7f",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedProbable.includes(row.TXN_ID)}
                        onChange={(event) => handleOnSelect(row, event.target.checked)}
                      />
                    </td>

                    {allFieldOrder.map((field) => {
                      const column = columnsByField[field];
                      const formatter = column?.formatter;
                      const renderedValue = formatter
                        ? formatter(row[field], row, rowIndex)
                        : displayNullFormatter(row, field);

                      return (
                        <td
                          key={`${row.TXN_ID || rowIndex}-${field}`}
                          style={{
                            ...commonStyle,
                            width: getColumnWidth(field),
                            verticalAlign: "middle",
                            borderTop: "none",
                            borderLeft: "none",
                            borderRight: "none",
                            borderBottom: "1px solid #4f2d7f",
                          }}
                        >
                          {renderedValue}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPageProbable}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={pageNoProbable > 0 ? pageNoProbable - 1 : 0}
                
          />
        </>
      ) : (
        <NoData />
      )}
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"User Comment"}</Typography>
            <CloseIcon
              onClick={handleCloseComment}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div>
            <UserComment commentRow={commentRow} handleSubmit={props.handleSubmit} handleCloseComment={handleCloseComment}/>
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default Table;

